/**
 * @generated SignedSource<<c9f0fe04ca9b683cb816ac362fef3e66>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AIAssetLibrarySortBy = "CREATED_DATE" | "NAME";
export type SortDirection = "ASC" | "DESC";
export type assetLibraryQueriesAIAssetLibraryAssetsQuery$variables = {
  assetType?: string | null;
  categoryID?: number | null;
  searchName?: string | null;
  sortBy?: AIAssetLibrarySortBy | null;
  sortDirection?: SortDirection | null;
  sourceToolID?: string | null;
};
export type assetLibraryQueriesAIAssetLibraryAssetsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"assetsGrid_query">;
};
export type assetLibraryQueriesAIAssetLibraryAssetsQuery = {
  response: assetLibraryQueriesAIAssetLibraryAssetsQuery$data;
  variables: assetLibraryQueriesAIAssetLibraryAssetsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceToolID"
},
v6 = {
  "kind": "Variable",
  "name": "assetType",
  "variableName": "assetType"
},
v7 = {
  "kind": "Variable",
  "name": "categoryID",
  "variableName": "categoryID"
},
v8 = {
  "kind": "Variable",
  "name": "searchName",
  "variableName": "searchName"
},
v9 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v10 = {
  "kind": "Variable",
  "name": "sortDirection",
  "variableName": "sortDirection"
},
v11 = {
  "kind": "Variable",
  "name": "sourceToolID",
  "variableName": "sourceToolID"
},
v12 = [
  (v6/*:: as any*/),
  (v7/*:: as any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v8/*:: as any*/),
  (v9/*:: as any*/),
  (v10/*:: as any*/),
  (v11/*:: as any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationSeconds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesAIAssetLibraryAssetsQuery",
    "selections": [
      {
        "args": [
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "assetsGrid_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v5/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "assetLibraryQueriesAIAssetLibraryAssetsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v12/*:: as any*/),
        "concreteType": "AiAssetLibraryAssetsConnection",
        "kind": "LinkedField",
        "name": "aiAssetLibraryAssets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiAssetLibraryAssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AIAssetLibraryAssetDTO",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assetType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceToolID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileServerID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filePath",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileSizeBytes",
                    "storageKey": null
                  },
                  (v13/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetGenerationSettings",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "toolId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "toolName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prompt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "negativePrompt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "model",
                        "storageKey": null
                      },
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "seed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "strength",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "steps",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "guidanceScale",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourceImageUrls",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "styleImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maskImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backgroundPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backgroundImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clothingPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clothingImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "posePreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "effectPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surfacePreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moodPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "materialPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "layoutPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stylePreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "videoPreset",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scaleFactor",
                        "storageKey": null
                      },
                      (v15/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resolution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aspectRatio",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "generateAudio",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "language",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subtitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "savedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modifiedDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*:: as any*/),
        "filters": [
          "categoryID",
          "assetType",
          "sourceToolID",
          "searchName",
          "sortBy",
          "sortDirection"
        ],
        "handle": "connection",
        "key": "assetsGrid_aiAssetLibraryAssets",
        "kind": "LinkedHandle",
        "name": "aiAssetLibraryAssets"
      }
    ]
  },
  "params": {
    "cacheID": "1567c8bbfb0b47003eeccc93c48d82f5",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesAIAssetLibraryAssetsQuery",
    "operationKind": "query",
    "text": "query assetLibraryQueriesAIAssetLibraryAssetsQuery(\n  $categoryID: Int\n  $assetType: String\n  $sourceToolID: String\n  $searchName: String\n  $sortBy: AIAssetLibrarySortBy\n  $sortDirection: SortDirection\n) {\n  ...assetsGrid_query_3nQcsc\n}\n\nfragment assetsGrid_query_3nQcsc on Query {\n  aiAssetLibraryAssets(first: 50, categoryID: $categoryID, assetType: $assetType, sourceToolID: $sourceToolID, searchName: $searchName, sortBy: $sortBy, sortDirection: $sortDirection) {\n    edges {\n      node {\n        id\n        categoryID\n        name\n        assetType\n        sourceToolID\n        fileServerID\n        filePath\n        fileName\n        fileUrl\n        fileSizeBytes\n        width\n        height\n        durationSeconds\n        thumbnailUrl\n        metadata {\n          toolId\n          toolName\n          prompt\n          negativePrompt\n          model\n          width\n          height\n          seed\n          strength\n          steps\n          guidanceScale\n          sourceImageUrls\n          styleImageUrl\n          maskImageUrl\n          backgroundPreset\n          backgroundImageUrl\n          personPreset\n          personImageUrl\n          clothingPreset\n          clothingImageUrl\n          posePreset\n          effectPreset\n          surfacePreset\n          moodPreset\n          materialPreset\n          colorPreset\n          layoutPreset\n          stylePreset\n          videoPreset\n          scaleFactor\n          durationSeconds\n          resolution\n          aspectRatio\n          generateAudio\n          language\n          title\n          subtitle\n          ctaText\n          savedAt\n        }\n        createdDate\n        modifiedDate\n        categoryName\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a32d64e72de57a269d4b52598171621";

export default node;
